<template>
    <div>
        <Table ref="standPaginationTable"
            :columns="columns"
            :data="data"
            :loading="loading"
            :size="size"
            :border="true"
            :stripe="true"
            :height="tableHeight"
            @on-select="onSelect"
            @on-selection-change="onSelectionChange"
            @on-row-dblclick = "onrowdblclick"
            @on-sort-change="onSortChange" />
        <Page v-if="showPage"
            :total="tableSearch.limit.conditions.total"
            :page-size="tableSearch.limit.conditions.pageLength"
            :current="tableSearch.limit.conditions.pageStart"
            :page-size-opts="pageSizeOptions"
            class="page"
            size="small"
            show-elevator
            show-sizer
            show-total
            placement="top"
            @on-change="tablePageOnChange"
            @on-page-size-change="tablePageOnSizeChange" />
    </div>
</template>

<script>
import search from '@/libs/search';
import { number2ThousandsFormat } from '@/libs/logic.js';
//import { number } from 'echarts/lib/export';

export default {
    name: 'StandPaginationTable',
    props: {
        columns: { type: Array, required: true },
        data: { type: Array, required: true },
        loading: { type: Boolean, required: true },
        size: { type: String, default: 'small' },
        extHeight: { type: Number, default: 0 },
        autoHeight: { type: Boolean, default: false },
        tableSearch: { type: Object, required: true },
        tableLoadEvent: { type: Function, required: true },
        pageSizeOptions: {
            type: Array,
            default: () => {
                return search.getSizeConfig();
            }
        },
        showPage: { type: Boolean, default: true }
    },
    data() {
        return {
            search,
            tableHeight: 400
        };
    },
    mounted() {
        if (this.autoHeight) {
            this.tableHeight = null;
        }
        else {
            this.tableHeight = window.innerHeight - this.$refs.standPaginationTable.$el.offsetTop - 240 - this.extHeight;
        }
    },
    methods: {
        tablePageOnChange(pageIndex) {
            search.globalPageOnChange(this.tableSearch, pageIndex);
            this.tableLoadEvent();
        },
        tablePageOnSizeChange(pageSize) {
            search.globalSizeOnChange(this.tableSearch, pageSize);
            this.tableLoadEvent();
        },
        onSelect(selection, row) {
            this.$emit('on-select', selection, row);
        },
        onSelectionChange(selection) {
            this.$emit('on-selection-change', selection);
        },
        onrowdblclick(row, index){
            this.$emit('on-row-dblclick', row, index);
        },
        onSortChange(column, key, order) {
            this.$emit('on-sort-change', column, key, order);
        }
    }
};
</script>

<style >


 .ivu-table-body::-webkit-scrollbar {  
     height: 20px!important;
        /* background-color: #C1C1C1 !important; */
   }

/* 设置滚动条滑块的样式 */
.ivu-table-body::-webkit-scrollbar-thumb {
  background: #C1C1C1 !important;;
}

</style>
